import { Dropdown, type MenuProps } from "antd";
import type { ReactNode } from "react";

export interface MoreButtonProps {
    current?: boolean;
    onRefresh?: () => void;
    onClose?: () => void;
    onCloseLeft?: () => void;
    onCloseRight?: () => void;
    onCloseOthers?: () => void;
    onCloseAll?: () => void;
    children: ReactNode;
}

/** 标签右键菜单，使用 zhihao-ui-react Dropdown 替代旧版 Element Plus 下拉菜单。 */
export function MoreButton({
    current = false,
    onRefresh,
    onClose,
    onCloseLeft,
    onCloseRight,
    onCloseOthers,
    onCloseAll,
    children
}: MoreButtonProps) {
    const items: MenuProps["items"] = [
        ...(current && onRefresh ? [{ key: "refresh", label: "刷新", onClick: onRefresh }] : []),
        ...(onClose ? [{ key: "close", label: "关闭", onClick: onClose }] : []),
        ...(onCloseLeft ? [{ key: "close-left", label: "关闭左侧", onClick: onCloseLeft }] : []),
        ...(onCloseRight ? [{ key: "close-right", label: "关闭右侧", onClick: onCloseRight }] : []),
        ...(onCloseOthers ? [{ key: "close-others", label: "关闭其它", onClick: onCloseOthers }] : []),
        ...(onCloseAll ? [{ key: "close-all", label: "关闭所有", onClick: onCloseAll }] : [])
    ];

    return (
        <Dropdown trigger={["contextMenu"]} menu={{ items }}>
            {children}
        </Dropdown>
    );
}

export default MoreButton;
